enum ETicketStatus {
  Unknown = 0,
  Sent = 1,
  Unsent = 2,
  NoMedia = 3,
  Connected = 4,
}

export default ETicketStatus
